<template>
  <div class="row">
    <div class="col-xl-5">
    </div>
    <div class="col-xl-2 text-center">
      <span role="status" class="spinner-grow text-primary"><span class="sr-only">Spinning</span></span>
    </div>
    <div class="col-xl-5">
    </div>
  </div>
</template>

<script>
export default {
  name: 'loader',
  props: [],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
  },

  methods: {
  },

  computed: {
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/misc/components/Loader.vue